module.exports = __webpack_public_path__ + "img/1482460840.646b42ad.jpg";